import { connect } from 'react-redux';
import { getTicketById, getMachines, updateTicketById, resetMeta, resetPage } from '../../actions/ReserveMachinePage';
import ReserveMachinePage from './ReserveMachinePage';


const mapsStateToProps = state => ({
	reserveMachinePageProps: state.reserveMachinePageReducer
});

const mapsDispatchToProps = dispatch => ({
	getTicketById(id) {
		dispatch(getTicketById(id));
	},
	getMachines(query) {
		dispatch(getMachines(query));
	},
	updateTicketById(options) {
		dispatch(updateTicketById(options));
	},
	resetPage() {
		dispatch(resetPage());
	},
	resetMeta() {
		dispatch(resetMeta());
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(ReserveMachinePage);
